<template>
  <div>
    <div class="mg-b-0 form-group autocomplete-wrap">
      <input
        type="text"
        class="form-control tx-13"
        :placeholder="$t('rm.原料供应商名称')"
        v-model="keyword"
        @blur="autoCompleteShow(false)"
        @focus="autoCompleteShow(true)"
        @keyup="getKeyword($event)"
      />
      <ul v-show="isAutoCompleteShow && keywordList.length > 0">
        <li v-for="(key, index) in keywordList" :key="key.id">
          <a
            href="javascript:;"
            :class="{ active: key.active }"
            v-text="key.name"
            @click="getName(index)"
            @mouseenter="activeChange(index)"
          ></a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: ["key_word", "noLike", "key_id"],
  data() {
    return {
      keyId: "",
      keyword: "",
      keyId1: "",
      keyword1: "",
      keywordList: [],
      timeout: {},
      isAutoCompleteShow: false,
      keyRid: "",
    };
  },
  watch: {
    key_id: function () {
      this.keyId = this.key_id;
    },
    key_word: function () {
      this.keyword = this.key_word;
    },
    keyword: function () {
      if (!this.keyword) {
        this.keywordList = [];
        this.keyId = "";
      }
      this.$emit("changeKeyword", this.keyword, this.keyId);
    },
    keywordList: function () {
      let vm = this;
      if (this.keywordList.length == 0) {
        this.keyId1 = "";
        this.keyword1 = "";
        this.$emit("keywordFilter", this.keyword1, this.keyId1);
      } else {
        vm.keyId1 = vm.keywordList[0].id;
        if (vm.keyId1 == "e999") return;
        for (let k in vm.keywordList[0]) {
          if (k != "id" && k != "active" && k != "rId" && k != "createUserId") {
            vm.keyword1 = vm.keywordList[0][k];
            break;
          }
        }
        vm.$emit("keywordFilter", vm.keyword1, vm.keyId1);
      }
    },
  },
  created() {
    this.keyword = this.key_word;
  },
  methods: {
    autoCompleteShow(status) {
      let vm = this;
      setTimeout(function () {
        vm.isAutoCompleteShow = status;
      }, 200);
    },
    getKeyword(e) {
      let key = e.keyCode;
      switch (key) {
        case 40: //上下回车
        case 38:
        case 13:
          this.keyAciton(key);
          break;
        default:
          let vm = this;
          let val = e.target.value;
          let reg = /^[\w | \s | \u4e00-\u9fa5]{2}/;
          if (!val) {
            vm.keywordList = [];
            return;
          }
          if ($("body").hasClass("side-top")) {
            if ($(".br-subleft").hasClass("left-more")) {
              $(".br-subleft .more-btn")
                .find("span")
                .text(this.$t("distributor.隐藏"));
              $(".br-subleft").removeClass("ht-54");
              $(".br-subleft .more-btn")
                .find("i")
                .removeClass("fa-angle-down")
                .addClass("fa-angle-up");
            }
          }
          if (val) {
            clearTimeout(vm.timeout);
            vm.timeout = setTimeout(function () {
              $.api_call(
                "api.SupplierProductStock.findRawSupplierByName",
                {
                  name: val,
                  page: 1,
                  rowsPerPage: 10,
                },
                function (r) {
                  if (r.ErrorCode == "9999") {
                    let data = r.Data.Results;
                    if (data.length > 0) {
                      vm.keywordList = data;
                      vm.keywordList.forEach((e, i) => {
                        for (let k in e) {
                          if (
                            k != "id" &&
                            k != "name" &&
                            k != "rId" &&
                            k != "createUserId"
                          ) {
                            if (String(e[k]).indexOf(val) < 0) {
                              delete e[k];
                            }
                          }
                        }
                        e.active = false;
                      });
                      if (vm.noLike) {
                        vm.keywordList[0].active = true;
                      }
                      if (vm.keywordList[0].active) {
                        vm.keyId1 = vm.keywordList[0].id;
                        if (vm.keyId1 == "e999") return;
                        for (let k in vm.keywordList[0]) {
                          if (
                            k != "id" &&
                            k != "active" &&
                            k != "rId" &&
                            k != "createUserId"
                          ) {
                            vm.keyword1 = vm.keywordList[0][k];
                            break;
                          }
                        }
                        vm.$emit("keywordFilter", vm.keyword1, vm.keyId1);
                      } else {
                        vm.keyId1 = "";
                        vm.keyword1 = "";
                      }
                    } else {
                      vm.keywordList = [
                        {
                          acitve: false,
                          categoryId1688: "e999",
                          id: "e999",
                          name: vm.$t("outside.没有可匹配客户"),
                        },
                      ];
                    }
                  } else {
                    if (r.ErrorCode == "1002") {
                      userFailure(vm);
                    } else {
                      ShowTip(r.Message, "danger");
                    }
                  }
                }
              );
            }, 300);
          } else {
            vm.keywordList = [];
          }
          break;
      }
    },
    getName(i) {
      this.keyId = this.keywordList[i].id;
      this.keyRid = this.keywordList[i].rId;
      if (this.keyId == "e999") return;
      this.keyword = this.keywordList[i].name;
      this.$emit("keywordEnter", this.keyword, this.keyId, this.keyRid);
      this.keywordList = [];
    },
    activeChange(i) {
      let vm = this;
      this.keywordList.forEach((e, index) => {
        e.active = false;
        if (index == i && e.id != "e999") {
          e.active = true;
          this.keyId = this.keywordList[index].id;
          if (this.keyId == "e999") return;
          this.keyword = this.keywordList[index].name;
          this.$emit("keywordFilter", this.keyword, this.keyId);
        }
      });
      vm.isAutoCompleteShow = !vm.isAutoCompleteShow;
      vm.isAutoCompleteShow = !vm.isAutoCompleteShow;
    },
    keyAciton(key) {
      let activeI = -1;
      switch (key) {
        case 38: //上
          if (this.keywordList.length <= 0) return;
          this.keywordList.forEach((e, i) => {
            if (e.active == true) {
              activeI = i;
            }
            e.active = false;
          });
          if (activeI <= 0) {
            if (this.keywordList[this.keywordList.length - 1].id != "e999") {
              this.keywordList[this.keywordList.length - 1].active = true;
              this.keyword = this.keywordList[this.keywordList.length - 1].name;
              this.keyId = this.keywordList[this.keywordList.length - 1].id;
            }
          } else {
            if (this.keywordList[activeI - 1].id != "e999") {
              this.keywordList[activeI - 1].active = true;
              this.keyword = this.keywordList[activeI - 1].name;
              this.keyId = this.keywordList[activeI - 1].id;
            }
          }
          this.$emit("keywordFilter", this.keyword, this.keyId);
          this.isAutoCompleteShow = !this.isAutoCompleteShow;
          this.isAutoCompleteShow = !this.isAutoCompleteShow;
          break;
        case 40: //下
          if (this.keywordList.length <= 0) return;
          this.keywordList.forEach((e, i) => {
            if (e.active == true) {
              activeI = i;
            }
            e.active = false;
          });
          if (activeI < this.keywordList.length - 1) {
            if (this.keywordList[activeI + 1].id != "e999") {
              this.keywordList[activeI + 1].active = true;
              this.keyword = this.keywordList[activeI + 1].name;
              this.keyId = this.keywordList[activeI + 1].id;
            }
          } else {
            if (this.keywordList[0].id != "e999") {
              this.keywordList[0].active = true;
              this.keyword = this.keywordList[0].name;
              this.keyId = this.keywordList[0].id;
            }
          }
          this.$emit("keywordFilter", this.keyword, this.keyId);
          this.isAutoCompleteShow = !this.isAutoCompleteShow;
          this.isAutoCompleteShow = !this.isAutoCompleteShow;
          break;
        case 13: //回车
          let vm = this;
          if (this.keywordList.length == 0) return;
          this.keyId = "";
          if (vm.keywordList[0].active) {
            vm.keyId1 = vm.keywordList[0].id;
            this.keyRid = this.keywordList[0].rId;
            if (vm.keyId1 == "e999") return;
            for (let k in vm.keywordList[0]) {
              if (
                k != "id" &&
                k != "active" &&
                k != "rId" &&
                k != "createUserId"
              ) {
                vm.keyword1 = vm.keywordList[0][k];
                break;
              }
            }
            this.keywordList = [];
            this.$emit("keywordEnter", this.keyword1, this.keyId1, this.keyRid);
          } else {
            this.keyId1 = "";
            this.keyword1 = "";
            this.$emit("keywordFilter", this.keyword1, this.keyId1);
            this.keywordList.forEach((e) => {
              if (e.active) {
                if (e.id == "e999") return;
                this.keyId = e.id;
                this.keyRid = e.rId;
                for (let k in e) {
                  if (
                    k != "id" &&
                    k != "active" &&
                    k != "rId" &&
                    k != "createUserId"
                  ) {
                    this.keyword = e[k];
                    break;
                  }
                }
              }
            });
            this.keywordList = [];
            this.$emit("keywordEnter", this.keyword, this.keyId, this.keyRid);
          }
          break;
      }
    },
  },
};
</script>

